import AxiosInstance from 'config/apiServiceApiGateway'

export type GetOjtSlotListResponseType = {
  data: OjtSlotListType[]
  pagination: OjtSloPaginationType
}

export type OjtSlotListType = {
  role: string
  off_day: number[]
  duration_in_days: number
  day_capacities: {
    day: number
    shift_capacities: {
      shift_id: number
      shift_name?: string
      max_capacity: number
    }[]
  }[]
}

export type OjtSloPaginationType = {
  prev_cursor: string
  next_cursor: string
  page_size: string
}

export type GetOjtSlotQueryParamsType = {
  location_id?: number
  role?: string
  page_size?: string
  cursor?: string
}

export type PostOjtSlotPayloadType = Omit<OjtSlotListType, 'off_day' | 'duration_in_days'> & {
  location_id: number
}

export type PostOjtSlotOffDayPayloadType = {
  location_id: number
  role: string
  off_day: number[]
}

export const getOjtSlotListApi = (params: GetOjtSlotQueryParamsType) =>
  AxiosInstance.Get<GetOjtSlotListResponseType, true>({
    url: '/staff-management/internal/:version/ojt-slotting',
    version: 'v1',
    params,
  })

export const postOjtSlotApi = (data: PostOjtSlotPayloadType) =>
  AxiosInstance.Post({
    url: '/staff-management/internal/:version/ojt-slotting',
    version: 'v1',
    data,
  })

export const postOjtSlotOffDayApi = (data: PostOjtSlotOffDayPayloadType) =>
  AxiosInstance.Post({
    url: '/staff-management/internal/:version/ojt-slotting/off-day',
    version: 'v1',
    data,
  })
